import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { GameService } from '../services/game.service';
import { Game } from '../_models/model';

@Injectable()
export class GameResolver implements Resolve<Game> {
  constructor(private gameService: GameService) {}

  resolve(route: ActivatedRouteSnapshot) {
    // console.log('game resolver called');

    const levelId = +route.parent?.params['id'];
    const gameId = +route.params['id'];

    return this.gameService.getGame(levelId, gameId);
  }
}
